import { render, staticRenderFns } from "./AknSwitch.vue?vue&type=template&id=0237f50e&scoped=true&"
import script from "./AknSwitch.vue?vue&type=script&lang=js&"
export * from "./AknSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AknSwitch.vue?vue&type=style&index=0&id=0237f50e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237f50e",
  null
  
)

export default component.exports